import { getFunctions } from 'firebase/functions'
import { initializeApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'
import {
  CACHE_SIZE_UNLIMITED,
  initializeFirestore,
  memoryLocalCache,
  memoryLruGarbageCollector
} from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getDatabase } from 'firebase/database'
import Environment from './environment'
import { getAuth } from 'firebase/auth'

export const firebaseApp = initializeApp(Environment.FIREBASE_CONFIG)
export const appCheck = Environment.RECAPTCHA_SITE_KEY
  ? initializeAppCheck(firebaseApp, {
      provider: new ReCaptchaEnterpriseProvider(Environment.RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    })
  : undefined
export const auth = getAuth(firebaseApp)
export const db = initializeFirestore(firebaseApp, {
  localCache: memoryLocalCache({
    garbageCollector: memoryLruGarbageCollector({
      cacheSizeBytes: CACHE_SIZE_UNLIMITED
    })
  }),
  ignoreUndefinedProperties: true
})
export const realtimeDb = getDatabase(firebaseApp)
export const functions = getFunctions(firebaseApp, 'southamerica-east1')
export const storage = getStorage(firebaseApp)
